"use client";

import Image from "next/image";
import MapHotspot from "./MapHotspot";

export type MapRegion = {
  id: string;
  label: string;
  description: string;
  bounds: {
    top: string;
    left: string;
    width: string;
    height: string;
  };
  polygon: string; // clip-path polygon
};

export default function Section4({
  image,
  MAP_REGIONS,
}: {
  image: string;
  MAP_REGIONS: MapRegion[];
}) {
  return (
    <section className="relative bg-white pt-20">
      {/* FULL WIDTH MAP */}
      <div className="relative w-full">
        <div className="relative w-full aspect-[992/487]">
          {/* MAP IMAGE */}
          <Image
            src="/images/map_ora.png"
            alt="Master Plan"
            fill
            priority
            className="object-contain"
          />

          {/* HOTSPOTS */}
          {MAP_REGIONS.map((region) => (
            <MapHotspot key={region.id} region={region} />
          ))}
        </div>
      </div>
    </section>
  );
}
